// none of these throw; window.localStorage is read inside the try since its getter throws when site data is blocked

export function readStored(key: string, storage?: Storage): string | null {
    try {
        return (storage ?? window.localStorage).getItem(key);
    } catch (e) {
        return null;
    }
}

// null removes the entry
export function writeStored(key: string, value: string | null, storage?: Storage): void {
    try {
        const target = storage ?? window.localStorage;
        if (value === null) target.removeItem(key);
        else target.setItem(key, value);
    } catch (e) {
        // the value just isn't kept
    }
}

// null = never stored, or not a boolean
export function readStoredBoolean(key: string, storage?: Storage): boolean | null {
    const raw = readStored(key, storage);
    if (raw === 'true') return true;
    if (raw === 'false') return false;
    return null;
}

export function writeStoredBoolean(key: string, value: boolean, storage?: Storage): void {
    writeStored(key, String(value), storage);
}
